import styled from 'styled-components';

export const Container = styled.div`
  margin-bottom: 50px;
  text-align: center;

  img {
    width: 198px;
    height: 182px;
  }
`;

export const Description = styled.div`
  font-weight: 800;
  color: #272727;

  p {
    font-size: 20px;
    line-height: 30px;
  }

  span {
    font-size: 18px;
    line-height: 27px;
    text-transform: uppercase;
  }
`;
